import { combineReducers } from '@reduxjs/toolkit';

import inventoryReducer from './inventory/inventory.slice';
import locationsReducer from './locations/locations.slice';
import metaReducer from './meta/meta.slice';
import newShipmentReducer from './newShipment/newShipment.slice';
import packagesReducer from './packages/packages.slice';
import reportsReducer from './reports/reports.slice';
import shipmentsReducer from './shipments/shipments.slice';
import stoneLookupReducer from './stoneLookup/stoneLookup.slice';
import suppliersReducer from './suppliers/suppliers.slice';
import trackingReducer from './tracking/tracking.slice';

const stoneReducer = combineReducers({
  inventory: inventoryReducer,
  meta: metaReducer,
  shipments: shipmentsReducer,
  newShipment: newShipmentReducer,
  packages: packagesReducer,
  locations: locationsReducer,
  suppliers: suppliersReducer,
  reports: reportsReducer,
  tracking: trackingReducer,
  stoneLookup: stoneLookupReducer,
});

export default stoneReducer;
